// src/pages/UploadPage/StoreActions/modal.js
import { useState } from 'react';

const useModal = () => {
  // Popup/Modal visibility states
  const [showCreateStorePopup, setShowCreateStorePopup] = useState(false);
  const [showUploadPopup, setShowUploadPopup] = useState(false);
  const [showRenamePopup, setShowRenamePopup] = useState(false);
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  
  // Modal data states
  const [itemToRemove, setItemToRemove] = useState(null);
  const [renameStoreName, setRenameStoreName] = useState('');
  const [editItem, setEditItem] = useState(null);
  
  // Success/Error message states
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  // Helper functions to open/close modals
  const openCreateStore = () => setShowCreateStorePopup(true);
  const closeCreateStore = () => setShowCreateStorePopup(false);
  
  const openUpload = (item = null) => {
    setEditItem(item);
    setShowUploadPopup(true);
  };
  const closeUpload = () => {
    setShowUploadPopup(false);
    setEditItem(null);
  };

  const openRename = (currentName = '') => {
    setRenameStoreName(currentName);
    setShowRenamePopup(true);
  };
  const closeRename = () => {
    setShowRenamePopup(false);
    setRenameStoreName('');
  };

  const openRemove = (item) => {
    setItemToRemove(item);
    setShowRemoveModal(true);
  };
  const closeRemove = () => {
    setShowRemoveModal(false);
    setItemToRemove(null);
  };

  // Clear messages
  const clearMessages = () => {
    setError(null);
    setSuccessMessage(null);
  };

  // Show success message temporarily
  const showSuccess = (message) => {
    setSuccessMessage(message);
    setError(null);
    // Auto-clear after 3 seconds
    setTimeout(() => setSuccessMessage(null), 3000);
  };

  // Show error message
  const showError = (message) => {
    setError(message);
    setSuccessMessage(null);
  };

  return {
    // Modal visibility states
    showCreateStorePopup,
    showUploadPopup,
    showRenamePopup, 
    showRemoveModal,
    
    // Modal data states
    itemToRemove,
    renameStoreName,
    editItem,
    
    // Message states
    error,
    successMessage,
    
    // Modal control functions
    openCreateStore,
    closeCreateStore,
    openUpload,
    closeUpload,
    openRename,
    closeRename,
    openRemove,
    closeRemove,
    
    // Message control functions
    clearMessages,
    showSuccess,
    showError,
    
    // Direct state setters (for backward compatibility)
    setShowCreateStorePopup,
    setShowUploadPopup,
    setShowRenamePopup,
    setShowRemoveModal,
    setItemToRemove,
    setRenameStoreName,
    setEditItem,
    setError,
    setSuccessMessage,
  };
};

export default useModal;